import { render } from "./RaqamliPortal.vue?vue&type=template&id=1218c38a"
import script from "./RaqamliPortal.vue?vue&type=script&lang=js"
export * from "./RaqamliPortal.vue?vue&type=script&lang=js"

import "./RaqamliPortal.vue?vue&type=style&index=0&id=1218c38a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__